module.exports = __webpack_public_path__ + "img/clock-twelve.6078da4b.svg";